import { Cpu, Shield, Sparkles, Zap, Bot, ScanLine } from "lucide-react";

const TECH = "https://images.pexels.com/photos/13027585/pexels-photo-13027585.jpeg";

export default function AITech() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14">
      <div className="text-xs uppercase tracking-[0.25em] text-zinc-500">AI Technology</div>
      <h1 className="mt-2 text-4xl sm:text-5xl font-bold tracking-tight max-w-3xl" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>The intelligence behind every humanized word.</h1>

      <div className="mt-10 relative h-56 rounded-3xl overflow-hidden border border-white/[0.06]">
        <img src={TECH} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50"/>
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/40 to-transparent"/>
        <div className="relative h-full flex items-center px-8 text-2xl font-bold max-w-md">
          Detection + paraphrasing + plagiarism — fused into one workflow.
        </div>
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-5">
        {[
          { i: ScanLine, t: "Originality.ai detection", d: "Every sentence is scored 0–100 for AI likelihood using Originality.ai's detection engine. Sentences above 60% are flagged for rewrite.", a: "Sentence-level scoring" },
          { i: Sparkles, t: "Humanize AI Pro paraphrasing", d: "Powered by Humanize AI Pro — academic-mode rewrites that preserve tone and meaning. We change words, not your voice.", a: "Avg. 0% AI in 1–3 rounds" },
          { i: Bot, t: "Gemini 2.5 Flash chatbot", d: "Built-in assistant powered by Gemini 2.5 Flash, aware of your plan, limits, and documents — answers any question instantly.", a: "Real-time" },
          { i: Shield, t: "Plagiarism scoring", d: "Plagiarism scoring runs alongside AI detection on every scan via Originality.ai, giving you a combined AI + plagiarism report in one pass.", a: "Inline scoring" },
          { i: Cpu, t: "Iterative paraphrase loop", d: "Paraphrase → re-scan → repeat. Each round only targets remaining flagged sentences until you hit 0% AI.", a: "Until 0%" },
          { i: Zap, t: "Multi-format support", d: "PDF, DOCX, PPTX, TXT, and image files (JPG, PNG, WEBP via OCR). Download cleaned output in your original format.", a: "7 file types" },
        ].map(({ i: Icon, t, d, a }, idx) => (
          <div key={idx} className="glass rounded-2xl p-6 hover:bg-white/[0.05] transition-colors">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-cyan-500/15 border border-cyan-500/30 flex items-center justify-center"><Icon size={18} className="text-cyan-300"/></div>
              <div className="flex-1">
                <div className="font-semibold">{t}</div>
                <div className="mt-1 text-sm text-zinc-400">{d}</div>
                <div className="mt-3 inline-block text-[10px] tracking-widest uppercase px-2 py-1 rounded glass text-cyan-300">{a}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
